import { fg } from '@atlaskit/platform-feature-flags/fg';

let isV2: boolean | undefined;
let cachedWorkspaceId: string | undefined;

/**
 * Sets the Studio V2 flag based on workspace context.
 * This should be called by AppSelector after workspace context is gathered.
 *
 * @param value - true if Studio V2, false if Studio V1
 */
export const setIsStudioV2 = (value: boolean): void => {
	isV2 = value;
};

/**
 * Caches the workspace ID that is either from the path or fetched remotely
 * @param workspaceId - the workspace ID to cache
 */
export const setCachedWorkspaceId = (workspaceId: string | undefined): void => {
	cachedWorkspaceId = workspaceId;
};

/**
 * Gets the cached workspace ID that is either from the path or fetched remotely
 * @returns the cached workspace ID
 */
export const getCachedWorkspaceId = (): string | undefined => cachedWorkspaceId;

export const isStudioV2 = (): boolean => {
	// This can be set by the dev tools modal to force v1
	if (fg('toggle-studio-v1')) {
		return false;
	}
	if (isV2 !== undefined) {
		return isV2;
	}

	return false;
};
